/* TODO: Удалить строки с игнорированием TS в задаче PUB-4328 (Оптимизация обработки кодов) */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { computed, type Ref } from 'vue'
import { cloneDeep } from 'lodash-es'
import { hasEnChild, hasOnlyEnChildren } from '../codesUtils'


export function useCodesForRepublication({
  isUserHasPublishingCodes,
  publicationCodes,
  newsCodes,
  iptcCode,
  regionsCode,
}: {
  isUserHasPublishingCodes: Ref<boolean>
  publicationCodes: Ref<any>
  newsCodes: Ref<any>
  iptcCode: Ref<(number | string)[]>
  regionsCode: Ref<(number | string)[]>
}) {
  function makeRepublicationCodes(filterFunc: (...args: any[]) => boolean) {
    if (isUserHasPublishingCodes.value) {
      const pubCodes = cloneDeep(publicationCodes.value ?? {})

      const codesForNews = cloneDeep(newsCodes.value ?? {})

      const filteredPubCodes = Object.entries(pubCodes)
        .filter(([_, code]) => filterFunc(pubCodes, code))
        .reduce((acc, [id, code]) => {
          let nonSelectable = Boolean(code.children) && code.children.length > 0
          if (
            code.track?.includes(iptcCode.value)
            || code.track?.includes(regionsCode.value)
          ) {
            nonSelectable = false
          }

          if (code.children) {
            acc[id] = {
              ...code,
              nonSelectable,
              /*
              Нам нужно перенести все направления публикации в начало списка, но
              сохранить их внутренний порядок.
              */
              pos: code.pos - 100000,
            }
          } else {
            acc[id] = { ...code }
          }
          return acc
        }, {})

      const filteredNewsCodes = Object.entries(codesForNews)
        .filter(([_, code]) => filterFunc(codesForNews, code))
        .reduce((acc, [id, code]) => {
          let nonSelectable = Boolean(code.children) && code.children.length > 0
          if (
            code.track?.includes(iptcCode.value)
            || code.track?.includes(regionsCode.value)
          ) {
            nonSelectable = false
          }
          acc[id] = {
            ...code,
            nonSelectable,
          }
          return acc
        }, {})

      return { ...filteredPubCodes, ...filteredNewsCodes }
    }

    return publicationCodes.value
  }

  return {
    ru: computed(() =>
      makeRepublicationCodes(
        (codeItems, code) => !hasOnlyEnChildren(codeItems, code),
      ),
    ),
    en: computed(() => makeRepublicationCodes(hasEnChild)),
  }
}
